// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { useDispatch, useSelector } from "react-redux";
import React, { useState, useRef, useCallback } from "react";

import Value from "src/components/chatroom/DueDate/Value";
import {
  DueDate as StyledDueDate,
  FloatContainer,
} from "src/components/chatroom/DueDate/styles";
import Calendar from "src/components/date/Calendar";
import { getDueDate, isStatusDisabled, getActiveState } from "src/reducers";
import { setAttribute } from "src/actions/chatroom";
import Tooltip from "src/components/Tooltip";
import useAutoPositionDropdown from "src/hooks/useAutoPositionDropdown";
import { getDueDate as getDate } from "src/utils";
import { convertToUTCMidnight } from "src/utils/checklist";

import type { RoomId } from "src/types";

type Props = {
  location: string,
  roomId: RoomId,
};

const DueDate = ({ roomId, location }: Props) => {
  const [dropdown, setDropdown] = useState(false);
  const outerRef = useRef(null);
  const edit = dropdown;
  const { fieldRef, dropdownRef, positionUp } = useAutoPositionDropdown({
    edit,
  });

  const dispatch = useDispatch();

  const dueDate = useSelector(({ app }) => getDueDate(app, roomId));
  const active = useSelector(({ app }) => getActiveState(app, roomId));
  const disabled = useSelector(({ app }) => isStatusDisabled(app, roomId));
  const value: string | Object = getDate(dueDate);

  const handleDropdown = useCallback(() => {
    setDropdown(!dropdown);
  }, [dropdown, setDropdown]);

  const handleDueDate = useCallback(
    (dueDate: ?Date) => {
      const utcDate = convertToUTCMidnight(dueDate);
      dispatch(
        setAttribute(
          roomId,
          {
            dueDate: utcDate,
          },
          location,
        ),
      );
    },
    [roomId, location],
  );

  if (disabled) {
    return <></>;
  }
  return (
    <StyledDueDate
      onClick={handleDropdown}
      onKeyPress={handleDropdown}
      ref={outerRef}
      data-cy={`due-date-header`}
    >
      <Tooltip title={i18n.t(k.SET_DUE_DATE)}>
        <span>
          <Value value={value} active={active} fieldRef={fieldRef} />
        </span>
      </Tooltip>

      {dropdown ? (
        <FloatContainer
          top="0px"
          bottom="0px"
          right={location === "activity-panel" ? "-60px" : "0px"}
        >
          <Calendar
            dropdownRef={dropdownRef}
            positionUp={positionUp}
            handleChange={handleDueDate}
            outerRef={outerRef.current}
            value={value}
            handleClose={handleDropdown}
          />
        </FloatContainer>
      ) : null}
    </StyledDueDate>
  );
};

export default DueDate;
